import React from "react";
import "./App.css";
import Main from "./containers/Main";
import { ThemeProvider } from "styled-components";
import { chosenTheme } from "./theme";
import { GlobalStyles } from "./global";
import StaleNotice from "./components/staleNotice/StaleNotice";

function App() {
  return (
    <ThemeProvider theme={chosenTheme}>
      <>
        <GlobalStyles />
        <div>
          <Main theme={chosenTheme} />
          <StaleNotice theme={chosenTheme} />
        </div>
      </>
    </ThemeProvider>
  );
}

export default App;
